import React, {Component} from 'react';
import ReactCrop from 'react-image-crop';
import CropHandler from '../helpers/CropHandler';
import Portal from 'react-portal';
import Translator from 'bazinga-translator';

function isDefaultValue(cropValues) {
    return cropValues.height === 0 && cropValues.width === 0
}

function isNotDefined(cropValues) {
    return cropValues === undefined;
}

function initEscapeEvent() {
}

export default class CropPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            cropValues: props.cropValues
        };
        this.CropHandler = {};
        this.cancelCropPopup = this.cancelCropPopup.bind(this);
        this.closeOnEsc = this.closeOnEsc.bind(this);
        this.closeOnClickBackground = this.closeOnClickBackground.bind(this);
    }

    componentDidMount() {
        const {filter, reference, cropValues} = this.props;
        this.CropHandler = new CropHandler(reference, filter, cropValues);
        document.body.style.overflow = 'hidden';
        console.log('true');

        window.addEventListener('keydown', this.closeOnEsc, false);

        this.refs.popupBackground.addEventListener('mouseDown', this.closeOnClickBackground, false);

        const isntDefined = this.state.cropValues === undefined;
        if (isntDefined) {
            this.setState({
                ...this.state,
                cropValues: {
                    x: 0,
                    y: 0,
                    ratio: null,
                    height: 50,
                    width: 50,
                }
            })
            return false
        }

        const isDefaultCrop = isDefaultValue(this.state.cropValues);
        if (isDefaultCrop) {
            this.setState({
                ...this.state,
                cropValues: {
                    ...this.state.cropValues,
                    width: 50,
                }
            })
        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reference !== this.props.reference) {
            const {filter, reference, cropValues} = nextProps;
            this.CropHandler.update(reference, filter, cropValues)
        }
    }

    componentDidUpdate(prevProps, prevState) {
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
        window.removeEventListener('keydown', this.closeOnEsc, false);
        this.refs.popupBackground.removeEventListener('click', this.closeOnClickBackground, false);
    }

    cancelCropPopup(e) {
        e.preventDefault();
        this.props.onCancel();
    }

    closeOnClickBackground(e) {
        if (e.target.contains(this.refs.popupContent)) {
            this.props.onCancel();
        }
    }

    closeOnEsc(e) {
        if (e.keyCode === 27) {
            this.props.onCancel();
        }
    }

    handleSizeChange(crop) {
        const newCropValues = {...this.state.cropValues, ...crop};
        this.CropHandler.setSettings(newCropValues);
        this.setState({
            ...this.state,
            cropValues: newCropValues
        });

    }

    handleCrop() {
        this.CropHandler.postCrop(this.state.cropValues, this.props.onCrop);
    }

    render() {
        return (
            <div className="crop-popup" ref="popupBackground">
            <div className="crop-popup__container" ref="popupContent">
                <div className="pop-up__content">
                    <h2>{Translator.trans('media_uploader.popup.header', [], 'app')}</h2>
                </div>
                <div className="crop-popup__content">
                    <ReactCrop src={this.props.src}
                               crop={this.state.cropValues}
                               onComplete={::this.handleSizeChange}/>
                    <div className="pop-up__buttons">
                        <a className="btn-popup" href="#" onClick={::this.cancelCropPopup}>{Translator.trans('cancel', [], 'app')}</a>
                        <a href="#" className="btn-popup -primary" onClick={
                            (e)=>{
                                e.preventDefault();
                                return this.handleCrop()
                        }}>
                            {Translator.trans('media_uploader.popup.crop', [], 'app')}</a>
                    </div>
                </div>
            </div>
        </div>

        )
    }

};



// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/CropPopup.jsx